import React, { useState, useEffect } from "react";
import styled, { ThemeProvider, createGlobalStyle } from "styled-components";
import { BrowserRouter as Router } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { darkTheme, lightTheme } from "./utiles/Themes";
import Navbar from "./components/Navbar";
import Hero from "./components/herosection";
import Skills from "./components/skills";
import CodingProfile from "./components/CodingProfile";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Education from "./components/Education";
import { TimeLine } from "./components/Timeline/TimeLine";
import Contact from "./components/Contact";
import Footer from "./components/footer";
import ProjectDetails from "./components/projectDetails";
import ScrollProgress from "./components/common/ScrollProgress";

gsap.registerPlugin(ScrollTrigger);

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Sora', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: ${({ theme }) => theme.bg};
    color: ${({ theme }) => theme.text_primary};
    overflow-x: hidden;
    transition: background-color 0.25s ease, color 0.25s ease;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => `${theme.primary}66`};
    border-radius: 999px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.primary};
  }

  ::selection {
    background: ${({ theme }) => theme.primary};
    color: #030712;
  }
`;

const AppContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: ${({ theme }) =>
    `radial-gradient(circle at 12% 8%, ${theme.secondary}1a 0%, transparent 35%),
     radial-gradient(circle at 88% 15%, ${theme.primary}18 0%, transparent 40%),
     ${theme.bg}`};
`;

const SectionWrapper = styled.div`
  background:
    radial-gradient(circle at 75% 20%, ${({ theme }) => `${theme.primary}12`} 0%, transparent 40%),
    linear-gradient(180deg, transparent 0%, ${({ theme }) => `${theme.bgLight}80`} 100%);
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.border};
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

function App() {
  const [darkMode, setDarkMode] = useState(true);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  useEffect(() => {
    ScrollTrigger.refresh();
  }, []);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <GlobalStyle />
      <Router>
        <AppContainer>
          <ScrollProgress />
          <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />

          <main>
            <Hero />
            <SectionWrapper>
              <Skills />
              <CodingProfile />
              <Experience />
            </SectionWrapper>

            <Projects openModal={openModal} setOpenModal={setOpenModal} />

            <SectionWrapper>
              <Education />
              <TimeLine />
              <Contact />
            </SectionWrapper>
          </main>

          <Footer />

          {openModal.state && (
            <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
          )}
        </AppContainer>
      </Router>
    </ThemeProvider>
  );
}

export default App;
